// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2I8cx","legacyBtn":"MutateMid_legacyBtn__1tyUU"};